import React from 'react';

import BarPagesChart from '../components/BarPagesChart';



const categories = [
	{
		value: '0-100',
		label: '<100',
		color: '#FF5959',
	},
	{
		value: '100-200',
		label: '<200',
		color: '#FF7437',
	},
	{
		value: '200-300',
		label: '<300',
		color: '#FF7437',
	},
	{
		value: '300-400',
		label: '<400',
		color: '#FF7437',
	},
	{
		value: '400-500',
		label: '<500',
		color: '#FF7437',
	},
	{
		value: '500-600',
		label: '<600',
		color: '#FF9830',
	},
	{
		value: '600-700',
		label: '<700',
		color: '#FF9830',
	},
	{
		value: '700-800',
		label: '<800',
		color: '#FFB131',
	},
	{
		value: '800-900',
		label: '<900',
		color: '#FFB131',
	},
	{
		value: '900-1000',
		label: '>900',
		color: '#42CC67',
	},
];



type Props = {
	data: Array<{
		count: number;
		percentage: number;
		value: string;
	}>;
};

const HealthChart: React.FC<Props> = (props) => {
	const {
		data,
	} = props;

	const chartData = React.useMemo(
		() => {
			return categories.map((category) => {
				const item = data.find((item) => item.value === category.value);

				if (item) {
					return item;
				}

				return {
					count: 0,
					percentage: 0,
					value: category.value,
				};
			});
		},
		[
			data,
		]
	);

	return (
		<BarPagesChart
			categories={categories}
			data={chartData}
			name="health"
		/>
	);
};



export default React.memo(HealthChart);
